import React, { useState } from "react";
import LanguageSelector from "./LanguageSelector";
import { Shield, Bell, Settings } from "lucide-react";

interface HeaderProps {
  showDeleteButton?: boolean;
  onDeleteAccount?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  showDeleteButton = false,
  onDeleteAccount,
}) => {
  var arg = new URLSearchParams(window.location.search);

  return (
    <header className="bg-white border-b border-slate-100 h-20 flex items-center shrink-0 z-40">
      <div className="w-full px-8 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-3 pl-10 lg:pl-0">
            {/* <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-blue-200">
              <Shield size={24} />
            </div> */}
            <img
              src={
                "https://" +
                (arg.get("s") === "khutbah" || arg.get("s") === "transit"
                  ? arg.get("s") + "captioning.com/images/logo-dark.svg"
                  : "conferencecaptioning.com/images/logo.png")
              }
              alt="Logo"
              className="h-14 w-auto object-contain"
            />
          </div>
        </div>

        <div className="flex items-center gap-6">
          <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-slate-50 rounded-full border border-slate-100 text-slate-500 text-xs font-bold uppercase tracking-wider">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
            System Live
          </div>

          {/* <div className="flex items-center gap-2">
            <button className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all">
              <Bell size={20} />
            </button>
            <button className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all">
              <Settings size={20} />
            </button>
          </div> */}

          <div className="h-8 w-px bg-slate-100 mx-2" />

          <LanguageSelector />
        </div>
      </div>
    </header>
  );
};

export default Header;
